import { render } from "./PMyWallet.vue?vue&type=template&id=f1a19462&scoped=true"
import script from "./PMyWallet.vue?vue&type=script&lang=js"
export * from "./PMyWallet.vue?vue&type=script&lang=js"

import "./PMyWallet.vue?vue&type=style&index=0&id=f1a19462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a19462"]])

export default __exports__